// LOGIN
export const login = (user) => {
  localStorage.setItem('authTokenCustomer', JSON.stringify(user));
};

// LOGOUT
export const logout = () => {
  localStorage.removeItem('authTokenCustomer');
  localStorage.removeItem('companyId');
  // localStorage.clear();
};

// LOGIN STATUS
export const isLogin = () => {
  var myObj = JSON.parse(localStorage.getItem('authTokenCustomer'));
  var size = myObj ? Object.keys(myObj).length : 0;
  if (size > 0) return true;
  return false;
};

// GET LOGIN DATA
export const getLoginData = () => {
  return JSON.parse(localStorage.getItem('authTokenCustomer'));
};
